/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { InstitutionProductTypeModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class InstitutionProductsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags ProductFeatureConfigurations
   * @name ProductFeatureConfigurationsGetInstitutionProducts
   * @summary Provides the list of Products available for the Institution.
   * @request GET:/InstitutionProducts
   */
  productFeatureConfigurationsGetInstitutionProducts = (
    params: RequestParams = {},
  ) =>
    this.http.request<InstitutionProductTypeModelDto[], any>({
      path: `/InstitutionProducts`,
      method: "GET",
      format: "json",
      ...params,
    });
}
